import Captcha from "react-numeric-captcha";
import { useState, useEffect, useRef } from "react";
import { Modal, Table, Button } from "react-bootstrap";
import axios from "axios";
import { Formik } from "formik";
import { apiStagingOutdoorUrl } from "../../../../../../constants";
import * as Yup from "yup";
import { generateYearsList } from "../../../../../../services/YearService";

const DrtRC = () => {
  const [captchaStatus, setCaptchaStatus] = useState(false);
  const years = generateYearsList();

  const capt = useRef();

  // state to control Model
  const [isOpenModal, setIsOpenModal] = useState(false);

  // fetching first dropDownData
  const [dratDrtLocations, setDratDrtLocations] = useState([]);
  const fetchDratDrtLocation = async () => {
    const res = await axios.post(
      `${apiStagingOutdoorUrl}/getDrtDratScheamName`
    );
    const sortedLocation = res.data.sort((a, b) =>
      a.SchemaName > b.SchemaName ? 1 : b.SchemaName > a.SchemaName ? -1 : 0
    );
    setDratDrtLocations(sortedLocation);
  };

  // function to fetch data after final post call
  const [loading, setLoading] = useState(false);
  const [caseDetail, setCaseDetail] = useState([]);
  const [error, setError] = useState(false);
  const fetchCaseDetail = async (url, data) => {
    setLoading(true);
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const response = await axios.post(
        `${apiStagingOutdoorUrl}/${url}`,
        data,
        config
      );
      setCaseDetail(response.data);
    } catch (error) {
      setCaseDetail([]);
      setLoading(false);
      setError(true);
    }
    setLoading(false);
  };

  // form data initial values
  const initialValues = {
    drt: "",
    orderType: "",
    caseType: "",
    rcNo: "",
    rcYear: new Date().getFullYear(),
  };

  // validation
  const validationSchema = Yup.object({
    drt: Yup.string().required("Required"),
    orderType: Yup.string().required("Required"),
    caseType: Yup.string().required("Required"),
    rcNo: Yup.string()
      .trim()
      .max(8, "Maximum length is 8 characters")
      .matches(/^[0-9]+$/, "Only numbers are allowed")
      .required("Required"),
    rcYear: Yup.string().required("Required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    const caseDetailData = {
      schemeNameDrtId: values.drt,
      dailyFinalOrderId: values.orderType,
      caseType: values.caseType,
      dailyFinalRcNo: values.rcNo,
      dailyFinalRcYear: values.rcYear,
    };

    fetchCaseDetail("getRcTrcDailyFinalOrderRcNo", caseDetailData);
    setTimeout(() => {
      setIsOpenModal(true);
    }, 1000);

    setCaptchaStatus(false);
    capt.current.refresh();
    // resetForm();
  };

  // loading captcha engine
  useEffect(() => {
    fetchDratDrtLocation();
  }, []);

  const doubleDigitDate = (date) => {
    // let date = "25/8/2022"
    if (date) {
      let arr = date.split("/");
      if (arr[0].length === 1) arr[0] = "0" + arr[0];
      if (arr[1].length === 1) arr[1] = "0" + arr[1];

      return arr.join("/");
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              {/* field 1 */}
              <div className="form-group row">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-4 col-form-label mandatory"
                >
                  DRT
                </label>
                <div className="col-sm-7">
                  <select
                    className="form-control"
                    placeholder=""
                    type="text"
                    id="drt"
                    name="drt"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.drt}
                  >
                    <option>Select DRT</option>
                    {dratDrtLocations
                      .filter((item) => parseInt(item.schemeNameDrtId) < 100)
                      .map((item, index) => (
                        <option value={`${item.schemeNameDrtId}`} key={index}>
                          {item.SchemaName}
                        </option>
                      ))}
                  </select>
                  {touched.drt && errors.drt ? (
                    <div className="error">{errors.drt}</div>
                  ) : null}
                </div>
              </div>
              {/* field 2 */}
              <div className="form-group row">
                <label htmlFor="" className="col-sm-4 col-form-label mandatory">
                  Daily/Final Order
                </label>
                <div className="col-sm-7">
                  <select
                    id="orderType"
                    name="orderType"
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChange}
                    value={values.orderType}
                    onBlur={handleBlur}
                  >
                    <option>Select Daily/Final Order</option>
                    <option value={1}>Daily Order</option>
                    <option value={2}>Final Order</option>
                  </select>
                  {touched.orderType && errors.orderType ? (
                    <div className="error">{errors.orderType}</div>
                  ) : null}
                </div>
              </div>
              {/* field 3 */}
              <div className="form-group row">
                <label htmlFor="" className="col-sm-4 col-form-label mandatory">
                  Case Type
                </label>
                <div className="col-sm-7">
                  <select
                    id="caseType"
                    name="caseType"
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChange}
                    value={values.caseType}
                    onBlur={handleBlur}
                  >
                    <option>Select Case Type</option>
                    <option value={"99999"}>RC</option>
                    <option value={"44444"}>TRC</option>
                  </select>
                  {touched.caseType && errors.caseType ? (
                    <div className="error">{errors.caseType}</div>
                  ) : null}
                </div>
              </div>
              {/* field 4 */}
              <div className="form-group row">
                <label htmlFor="" className="col-sm-4 col-form-label mandatory">
                  RC No.
                </label>
                <div className="col-sm-7">
                  <input
                    id="rcNo"
                    name="rcNo"
                    type="text"
                    className="form-control"
                    placeholder="Enter RC No."
                    onChange={handleChange}
                    value={values.rcNo}
                    onBlur={handleBlur}
                    autoComplete="off"
                  />
                  {touched.rcNo && errors.rcNo ? (
                    <div className="error">{errors.rcNo}</div>
                  ) : null}
                </div>
              </div>
              {/* field 5 */}
              <div className="form-group row">
                <label htmlFor="" className="col-sm-4 col-form-label mandatory">
                  RC Year
                </label>
                <div className="col-sm-7">
                  <select
                    type="text"
                    className="form-control"
                    placeholder=""
                    id="rcYear"
                    name="rcYear"
                    onChange={handleChange}
                    value={values.rcYear}
                    onBlur={handleBlur}
                  >
                    {years.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </select>
                  {touched.rcYear && errors.rcYear ? (
                    <div className="error">{errors.rcYear}</div>
                  ) : null}
                </div>
              </div>
              {/* field 6 */}
              <div className="form-group capcha-sec">
                <div className="col-sm-12 px-0 d-flex">
                  <Captcha
                    onChange={(status) => {
                      setCaptchaStatus(status);
                    }}
                    ref={capt}
                    required
                  />
                  <br />
                  <button
                    type="submit"
                    disabled={!captchaStatus}
                    className="btn btn-reload"
                  >
                    <i className="fas fa-search">
                      <span className="sr-only">no text</span>
                    </i>
                  </button>
                </div>
                {!captchaStatus ? (
                  <div className="captcha-text">Enter valid captcha</div>
                ) : null}
              </div>
            </form>
            {loading ? (
              <h6 className="loader">Loading ...</h6>
            ) : (
              <Modal show={isOpenModal} onHide={() => setIsOpenModal(false)}>
                <Modal.Header className="d-flex justify-content-between align-items-start">
                  RC/TRC Daily/Final Order Report
                  <Button
                    type="button"
                    className="close"
                    onClick={() => setIsOpenModal(false)}
                  >
                    &times;
                  </Button>
                </Modal.Header>
                <Modal.Body>
                  <div className="table-responsive">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Sr.No.</th>
                          <th>
                            <center>Applicant V/S Respondent</center>
                          </th>
                          <th>Case No.</th>
                          <th>RC/TRC No.</th>
                          <th>Date of Order</th>
                          <th>RO Name</th>
                          <th>RC Daily/Final Order(s)</th>
                        </tr>
                      </thead>
                      {!error && caseDetail.length > 0 ? (
                        <tbody>
                          {caseDetail.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <center>
                                  {item.applicantName} <br />
                                  <strong>V/S</strong>
                                  <br />
                                  {item.respondentName}
                                </center>
                              </td>
                              <td>{item.caseno}</td>
                              <td>{item.rcno}</td>
                              <td>{doubleDigitDate(item.dateoforder)}</td>
                              <td>{item.roName}</td>
                              <td>
                                <a
                                  target="_blank"
                                  rel="noreferrer"
                                  href={`${item.orderPdf}`}
                                >
                                  <i className="fas fa-search">
                                    <span className="sr-only">no text</span>
                                  </i>
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan="8"> No Record Found </td>
                          </tr>
                        </tbody>
                      )}
                    </Table>
                  </div>
                </Modal.Body>
              </Modal>
            )}
          </>
        )}
      </Formik>
    </div>
  );
};

export default DrtRC;
